<template>
  <div data-app>
    <el-dialog
      class="dialogAddMember"
      :show-close="false"
      center
      :visible.sync="isShowDialog"
      :before-close="handleClose"
      :height="dialogMinHeight"
      :bottom="0"
    >
      <div class="wallet-container mb-20">
        <div style="position:relative;">
          <div style="padding-bottom: 0 !important;" class="container mt-3">
            <p class="title-dialog m-0">{{ $t("addUser") }}</p>
            <img @click="handleClose" :src="bg.icon_closed" alt="" />
          </div>
          <div
            style="padding-bottom: 0 !important; padding-top:10px"
            class="search-container container"
          >
            <div class="full-width  search-bar-container">
              <img style="margin-left:10px" :src="bg.icon_search" alt="" />
              <el-input
                @input="debouncedSearchGolfers"
                ref="inputSearchFacility"
                class="input-search-bar full-width"
                :placeholder="$t('wap.text151')"
                v-model="searchKeyword"
              >
              </el-input>
            </div>
          </div>
          <div
            style="max-height: 150px; overflow-y: auto;"
            class="container"
            ref="users_checked"
          >
            <div class="d-flex flex-wrap">
              <div
                v-for="(item, index) in list_golfer_out"
                :key="index"
                class="box-users-checked  mb-5 mr-5 d-flex algin-items-center"
              >
                <span class="mr-10">{{ item.fullname }}</span>
                <img
                  style="width:14px"
                  @click="handleRemoveOut(item)"
                  :src="bg.icon_closed_2"
                  alt=""
                />
              </div>
              <div
                v-for="item in list_golfer"
                :key="item.user_id"
                class="box-users-checked  mb-5 mr-5 d-flex algin-items-center"
              >
                <span class="mr-10"
                  >{{ item.id_display }} - {{ item.fullname }}</span
                >
                <img
                  style="width:14px"
                  @click="handleRemoveUser(item.user_id)"
                  :src="bg.icon_closed_2"
                  alt=""
                />
              </div>
            </div>
          </div>
          <div
            style="min-height: 200px;"
            v-if="isLoading"
            v-loading="isLoading"
            class="full-width"
          ></div>
          <el-row
            v-else
            style="padding-top: 16px;"
            class="full-width container"
            ref="users"
          >
            <el-col :xs="24" :sm="24" :md="24" :lg="24">
              <div class="full-width">
                <div v-if="userOut" class="full-width cursor-pointer">
                  <div
                    class="golf-course"
                    @click="addPlayerOut"
                    style="border-bottom: 0.81px solid var(--Border-Grey-Medium, #F6F6F6)"
                  >
                    <img
                      class="mr-10"
                      style="height: 38px; width:38px; object-fill: cover; border-radius: 50%; "
                      :src="logoDefault"
                      alt=""
                    />
                    <div class="info-golf-course full-width">
                      <h3 class="name-course fs-cv3 c-text-main">
                        {{ userOut }}
                      </h3>
                      <p class="address-course fs-cv4">
                        {{ $t("wap.text152") }}
                      </p>
                    </div>
                  </div>
                </div>
                <div v-if="phoneNotAccount" class="full-width cursor-pointer">
                  <div
                    class="golf-course"
                    @click="handleMapVid"
                    style="border-bottom: 0.81px solid var(--Border-Grey-Medium, #F6F6F6)"
                  >
                    <img
                      class="mr-10"
                      style="height: 38px; width:38px; object-fill: cover; border-radius: 50%; "
                      :src="logoDefault"
                      alt=""
                    />
                    <div class="info-golf-course full-width">
                      <h3 class="name-course fs-cv3 c-text-main">
                        {{ phoneNotAccount }}
                      </h3>
                      <p class="address-course fs-cv4">
                        {{ $t("wap.text179") }}
                      </p>
                    </div>
                  </div>
                </div>
                <div
                  v-if="listGolfer.length > 0"
                  class="full-width cursor-pointer golfContainer"
                >
                  <div
                    v-for="(item, index) in listGolfer"
                    class="golf-course"
                    @click="handleAddGolfer(item)"
                    :key="item.user_id"
                    style="border-bottom: 0.81px solid var(--Border-Grey-Medium, #F6F6F6)"
                  >
                    <img
                      class="mr-10"
                      style="height: 38px; width:38px; object-fill: cover; border-radius: 50%; "
                      :src="item.avatar || logoDefault"
                      @error="handleImageError(index)"
                      alt=""
                    />
                    <div class="info-golf-course full-width">
                      <h3 class="name-course fs-cv3 c-text-main">
                        {{ item.fullname }}
                      </h3>
                      <p class="address-course fs-cv4">
                        vID{{ item.id_display }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
      <div class="container box-btn">
        <ButtonCustomer
          :styles="{
            fontSize: '14px',
            fontWeight: 600,
            height: '40px',
            borderRadius: bg.b_radius2,
            background: bg.c_box_header_tee2
          }"
          :object-data="{ title: $t('addPerson') }"
          @on-action="handleClose"
        />
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getBackGround } from "@/utils/wapAuth";
import { formatNumber } from "@/plugins/init";
import TeeTimeResource from "@/views/api/wap/detail-tee-time";
import { debounce } from "lodash";
import ButtonCustomer from "@/components/wapV2/button/index.vue";
import { mapGetters, mapActions } from "vuex";
import { toggleChat } from "@/utils/helper";
import { validatePhoneNumber } from "@/utils/formatData";
import { loginWap } from "@/views/api/wapV2/user";

export default {
  name: "dialogAddMember",
  components: {
    ButtonCustomer
  },
  props: {
    isShowDialog: {
      type: Boolean,
      default: false
    },
    isViewsPrice: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      isLoading: false,
      longitude: null,
      latitude: null,
      logoDefault:
        "https://cdn.vcallid.com/8f4aff6a-9ea9-4977-962b-9334ee6c46b3.png",
      searchKeyword: "",
      listGolfer: [],
      bg: getBackGround(),
      isMobile: true,
      icons: {},
      playersNotSplice: "3213123343423423423",
      loadingMapVid: false
    };
  },
  created() {},

  computed: {
    ...mapGetters(["list_golfer", "list_golfer_out"]),
    dialogMinHeight() {
      return window.innerHeight * 0.9 + "px";
    },
    userOut() {
      if (!/^\d+$/.test(this.searchKeyword.trim())) return this.searchKeyword;
      return "";
    },
    phoneNotAccount() {
      if (this.searchKeyword.trim() != this.playersNotSplice) return "";
      if (
        this.validatePhoneNumber(this.searchKeyword.trim()) &&
        this.playersNotSplice
      )
        return this.searchKeyword;
      return "";
    }
  },
  watch: {
    isShowDialog: function(newValue, oldValue) {
      if (newValue) {
        this.hideOverflow();
        toggleChat(false);
      } else {
        toggleChat(true);
        this.showOverflow();
      }
    }
  },
  mounted() {},
  beforeDestroy() {},
  methods: {
    formatNumber,
    validatePhoneNumber,
    ...mapActions([
      "push_golfer",
      "remove_golfer",
      "push_golfer_out",
      "remove_golfer_out"
    ]),

    hideOverflow() {
      const dBody = document.body;
      document.documentElement.style.overflow = "hidden";
      if (!this.isViewsPrice) {
        dBody.style.position = "fixed";
        dBody.style.height = "100%";
        dBody.style.overflow = "hidden";
        dBody.style.width = "100%";
      }
    },
    showOverflow() {
      const dBody = document.body;
      dBody.style.position = "";
      dBody.style.height = "";
      dBody.style.width = "";
      dBody.style.overflow = "";

      document.documentElement.style.overflow = "";
    },
    isGolferSelected(id) {
      return this.list_golfer.some(i => i.user_id == id);
    },
    async handleMapVid() {
      if (this.isLoading) return;
      this.isLoading = true;
      const phone = this.searchKeyword.trim();
      if (this.validatePhoneNumber(phone)) {
        // const { data } = await axios.get("/api/login/mapping-account-vid", {
        //   params: {
        //     phone: this.searchKeyword
        //   }
        // });
        const body = {
          phone
        };
        const data = await loginWap(body);
        if (data.error_code == 0) {
          const res = data.data;
          const user = {
            user_id: res.vga,
            id_display: res.id_display,
            fullname: res.fullname
          };
          if (this.isGolferSelected(user.user_id)) {
            this.searchKeyword = "";
            this.isLoading = false;
            return;
          }
          this.push_golfer(user);
        }
        this.searchKeyword = "";
        this.isLoading = false;
      }
    },
    handleAddGolfer(player) {
      if (player) {
        this.listGolfer.splice(this.listGolfer.indexOf(player), 1);
        if (this.isGolferSelected(player.user_id)) return;
        this.push_golfer(player);
      }
    },
    addPlayerOut() {
      if (this.searchKeyword) {
        const data = { user_id: -1, fullname: this.searchKeyword, out: "" };
        this.push_golfer_out(data);
        this.searchKeyword = "";
      }
    },
    handleRemoveOut(item) {
      this.remove_golfer_out(item);
    },
    handleRemoveUser(golferId) {
      if (!golferId) return;
      // if (golferId == getToken().vga) {
      //   this.$message.warning("Không thể xóa chủ tài khoản.");
      //   return;
      // }
      this.remove_golfer(golferId);
    },
    handleImageError(index) {
      return this.logoDefault;
    },

    debouncedSearchGolfers: debounce(async function(keyword) {
      TeeTimeResource.searchGolfer(
        {},
        {
          keyword_golfer: keyword,
          page: 1,
          limit: 7,
          lang: "en"
        }
      )
        .then(res => {
          const data = res.data.data;
          this.listGolfer = data.map(i => ({
            user_id: i.id,
            avatar: i.avatar,
            fullname: i.fullname,
            id_display: i.id_display
          }));
          if (
            !this.validatePhoneNumber(this.searchKeyword.trim()) &&
            data.length == 0
          ) {
            this.playersNotSplice = "3213123343423423423";
          } else if (
            this.validatePhoneNumber(this.searchKeyword.trim()) &&
            data.length == 0
          ) {
            this.playersNotSplice = this.searchKeyword.trim();
          } else if (
            this.validatePhoneNumber(this.searchKeyword.trim()) &&
            data.length > 0
          ) {
            this.playersNotSplice = "3213123343423423423";
          }
        })
        .finally(() => {});
    }, 300),
    handleClose() {
      this.searchKeyword = "";
      this.$emit("close", true);
    }
  }
};
</script>
<style lang="scss">
.mt-15 {
  margin-top: 15px !important;
}
.mb-15 {
  margin-bottom: 15px !important;
}
.dialogAddMember .el-dialog {
  position: relative;
  border-radius: 10px;
  min-height: 10vh;
  height: 80vh;
  overflow: hidden;
  max-width: 500px !important;
  width: 100%;
  z-index: 1950;
  margin-bottom: 0 !important;
  margin-top: 10vh !important;

  .el-dialog__body {
    padding-top: 0 !important;
    padding-bottom: 0px !important;
    padding-left: 0 !important;
    padding-right: 0 !important;
  }

  .el-dialog__header {
    margin: 0;
    padding: 0;
  }
}
.el-tooltip__popper {
  display: none !important;
}

@media screen and (min-width: 0px) and (max-width: 600px) {
  .dialogAddMember .el-dialog {
    position: fixed;
    bottom: 0;
    margin-top: 20vh !important;
    border-radius: 20px;
    overflow: hidden;
    max-width: 550px !important;
    width: 100%;
    height: 80vh;
    z-index: 1950;
    margin-bottom: 0 !important;
    border-bottom-left-radius: 0 !important;
    border-bottom-right-radius: 0 !important;
  }
}
@media screen and (min-width: 0px) and (max-width: 380px) {
  .dialogAddMember .el-dialog {
    position: fixed;
    bottom: 0;
    margin-top: 10vh !important;
    border-radius: 30px;
    background: rgba(240, 241, 245, 1);
    height: 80vh;
    overflow: hidden;
    max-width: 550px !important;
    width: 100%;
    margin-bottom: 0 !important;
    z-index: 1950;

    border-bottom-left-radius: 0 !important;
    border-bottom-right-radius: 0 !important;
  }
}
@media screen and (max-width: 320px) and (max-height: 568px) {
  .dialogAddMember .el-dialog {
    margin-top: 10vh !important; /* Giảm khoảng cách từ trên xuống */
    height: 80vh;
    bottom: 0;
    min-height: auto; /* Bỏ giá trị cố định cho chiều cao tối thiểu */
    max-height: none; /* Bỏ giới hạn chiều cao tối đa */
    max-width: 100% !important; /* Đặt chiều rộng tối đa là 100% */
    border-radius: 0; /* Loại bỏ viền bo tròn */
    z-index: 1950;
  }
}
</style>

<style lang="scss" scoped>
$divider-color: #ececec;

$color-btn: v-bind("bg.c_button_main");
.title-dialog {
  color: var(--Foreground-Ink-Default, #1a1a1a);

  font-weight: 600;
  font-size: 14.56px;
  line-height: 19.41px;
  letter-spacing: 0%;
}
.box-btn {
  position: absolute;
  bottom: 0px;
  height: 60px;
  background-color: #ffff;
}
.box-users-checked {
  background-color: #f3f2f4;
  padding: 5px 10px;
  border-radius: v-bind("bg.b_radius2");
  color: v-bind("bg.c_input") !important;
  font-size: 12px;
}
.golfContainer {
  max-height: 540px;
  overflow-y: scroll; /* Để cho phép cuộn theo chiều dọc */
  scrollbar-width: none; /* Ẩn thanh cuộn trong Firefox */
}
/* Ẩn thanh cuộn trong Chrome, Safari và Opera */
.golfContainer::-webkit-scrollbar {
  display: none;
}
.search-bar-container {
  border: 0.87px solid v-bind("bg.c_border3");
  background: v-bind("bg.c_background1");
  border-radius: 100px;
  height: 45px;
  width: 100%;
  display: flex;
  align-items: center;
}
.info-golf-course {
  position: relative;
  padding-right: 20px;
  padding-bottom: 10px;
}
.address-course {
  color: #999999;
  font-size: 12px;
  margin: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 90%;
  height: 20px;
}
.name-course {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin: 0;
  font-weight: 500;
  max-width: 90%;
}
.golf-course {
  overflow: hidden;
  padding: 0;
  display: flex;
  margin-bottom: 10px;
}
.divider-view {
  height: 2px;
  width: 100%;
  margin: 5px 0;
  background-color: $divider-color;
}

.w-100 {
  width: 100%;
}
.mr-10 {
  margin-right: 10px;
}
@media screen and (min-width: 0px) and (max-width: 769px) {
  .desktop {
    display: none;
  }
  .mobile {
    display: block;
  }
}
@media screen and (min-width: 769px) and (max-width: 980px) {
}
</style>
